import {BoardComment, BoardEntity} from "../../../model/BoardEntity";
import {Accordion, Card, useAccordionToggle} from "react-bootstrap";
import React, {useState} from "react";
import 'moment-timezone';
import moment from "moment";
import {HttpMethod} from "../../../model";
import {httpClient} from "../../../service";
import parse from 'html-react-parser'
import {ForumType} from "../../../model/Enums";

const CustomToggle = (props: any) => {
    const children = props.children;
    const eventKey = props.eventKey;
    const date = props.date;
    const callback = props.onDetailChange;
    const isQna: boolean = props.qnaType;
    const isHelp: boolean = props.helpType;
    console.log(`isHelp=${isHelp}`);
    const detailView = async (id: any) => {
        const option = {
            url: `boards/detail/${id}`,
            method: HttpMethod.GET
        };
        const act = await httpClient(option);
        if (act.result) {
            const model: BoardEntity = act.data;
            console.log(`detail id=${id} model=${JSON.stringify(model)}`);
            if(model) {
                let content=model.content;
                if(model.forumType===ForumType.Qa){
                    if(model.comments && model.comments.length>0){
                        content +=`<div class='reply'>`;
                        content +=`<div><span class="oklabel">답변내용</span></div><div>`;
                        model.comments.forEach((v:BoardComment,index)=>{
                            const cstr=v.content ? v.content.replaceAll('\n','<br />'):'';
                            const nDate = moment(v.createDate, 'YYYY-MM-DD HH:mm:ss');
                                content +=`<div>${cstr}<p class="comment">${nDate.format('YY/MM/DD HH:mm:ss')}</p></div>`;
                        });
                        content +='</div></div>';
                    }
                }
                callback(content);
            }
        } else {
            console.error(`detail error ${act.errorMsg}`);
        }
    }
    const decoratedOnClick = useAccordionToggle(eventKey, async (e:any) => {
        e.preventDefault();
        await detailView(eventKey);
    });

    const nDate = moment(date, 'YYYY-MM-DD HH:mm:ss');
    if (isQna) {

        return (
            <>
                <a href="#decorated" className="a-btn title-link a-block" onClick={decoratedOnClick}>
                    <h6 className="default-text mg-clear">{children}</h6>
                    <p className="comment mg-clear">{nDate.format('YY/MM/DD HH:mm:ss')}</p>
                </a>
            </>
        );
    } else {
        return (
            <>

                <a href="#decoration" className="a-btn title-link a-block" onClick={decoratedOnClick}>
                    <h6  className="mg-clear comment" hidden={isHelp}>{nDate.format('YY/MM/DD')}</h6>
                    {children}
                </a>
            </>
        );
    }
}
const ListIndex = (props: any) => {
    const item: BoardEntity = props.item;
    const [content, setContent] = useState('');
    const isQna: boolean = props.qnaType;
    const isHelp: boolean = props.helpType;
    let subject: string = item.subject ?? '';
    console.log(item.comments);
    const isComment : boolean = item.comments === null || !isQna;
    let answerDate =  '';
    let answerContent = '';

    if(isQna){
        if(item.isAnswer && item.isAnswer === true){
            subject +=`&nbsp;<span class="oklabel">답변완료</span>`;
            if(item.comments && item.comments.length  >0 ){
                answerContent = `<div class='reply'>`;
                answerContent +=`<div><span class="oklabel">답변내용</span></div><div>`;
                item.comments.forEach((v:BoardComment, idx) => {
                   const cstr = v.content ? v.content.replaceAll(`\n` ,'<br />'):'';
                   const nDate = moment(v.createDate, 'YYYY-MM-DD HH:mm:ss');
                   answerContent +=`<div className="commont-text">${cstr}<p class="comment">${nDate.format('YY/MM/DD HH:mm:ss')}</p></div>`;
                });
                answerContent +='</div></div>';
            }
        }
    }

    function detailView(content: string) {
        console.log(`content=${content}`)
        setContent(content);
    }

    return (
        <Card className="border-0">
            <Card.Header>
                <CustomToggle eventKey={item.id} date={item.createDate} qnaType={isQna} helpType={isHelp}
                              onDetailChange={detailView}>
                    {parse(subject)}
                </CustomToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={item.id}>
                <Card.Body>
                    <div className="default-text">{parse(content.replaceAll('\n', '<br />'))}</div>
                    <div hidden={isComment} >
                        {parse(answerContent)}
                    </div>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    )
}

export default ListIndex;
